import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './stability.module.scss';

// 백엔드가 내려주는 점검 항목명 → 번역 키 슬러그.
// 왼쪽 문자열은 화면 문구가 아니라 데이터 키이므로 번역하지 않습니다.
const detailKeys = {
  'Disk Usage Check': 'diskUsage',
  'Disk Mount Check': 'diskMount',
  'Swap Memory Check': 'swapMemory',
  'Memory Usage Check': 'memoryUsage',
  'Network Link Check': 'networkLink',
  'Network Bond Check': 'networkBond',
  'Time Sync Check': 'timeSync',
  'Cpu Usage Check': 'cpuUsage',
  'Multipath Check': 'multipath',
  'Route Check': 'route'
};

const StabilityInfo = ({ stabilityMsg }) => {
  const { t } = useTranslation();

  // 메시지 파싱
  const messageLines = stabilityMsg ? stabilityMsg.split('\n').filter(line => line.trim()) : [];

  // 각 메시지 유형별 색상 및 아이콘 매핑
  const typeStyles = {
    'Disk Usage Check': { color: '#ff4d4f', icon: '💾' },
    'Disk Mount Check': { color: '#ff7a45', icon: '📁' },
    'Swap Memory Check': { color: '#ffa940', icon: '🔄' },
    'Memory Usage Check': { color: '#ffec3d', icon: '🧠' },
    'Network Link Check': { color: '#73d13d', icon: '🔌' },
    'Network Bond Check': { color: '#36cfc9', icon: '🔗' },
    'Time Sync Check': { color: '#40a9ff', icon: '⏰' },
    'Cpu Usage Check': { color: '#597ef7', icon: '⚙️' },
    'Multipath Check': { color: '#9254de', icon: '🛣️' },
    'Route Check': { color: '#f759ab', icon: '🧭' }
  };

  return (
    <div className={styles.stabilityContainer}>
      <h2 className={styles.stabilityTitle}>Stability Information</h2>
      
      {messageLines.length > 0 ? (
        <div className={styles.stabilityGrid}>
          {messageLines.map((line, index) => {
            const checkType = line.trim();
            const detailKey = detailKeys[checkType];
            const description = detailKey
              ? t(`summary.stability.detail.${detailKey}`)
              : t('summary.stability.unknown');
            const style = typeStyles[checkType] || { color: '#1890ff', icon: '❓' };
            
            return (
              <div key={index} className={styles.stabilityCard}>
                <div className={styles.cardHeader} style={{ backgroundColor: style.color }}>
                  <span className={styles.cardIcon}>{style.icon}</span>
                  <h3 className={styles.cardTitle}>{checkType}</h3>
                </div>
                <div className={styles.cardBody}>
                  <p className={styles.cardDescription}>{description}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.emptyMessage}>
          <p>{t('summary.stability.empty')}</p>
        </div>
      )}
    </div>
  );
};

export default StabilityInfo;
